import { PaymentTypes, PaymentTypesType } from 'services/api/PaymentApi/types/common'

import { IUser } from 'shared/models/User'

export const templateAmountByPaymentType: Record<PaymentTypesType, (number | string)[]> = {
  [PaymentTypes.DEPOSIT]: [300, 500, 1000, 2000, 5000],
  [PaymentTypes.PAYOUT]: [300, 500, 1000, 2000, '$USER_BALANCE'],
}

export const replaceTemplateValue = ({ balance }: { balance?: IUser['balance'] }): Record<string, number> => ({
  $USER_BALANCE: Number(balance),
})
